/**
 * @module IDEE/style/textoverflow
 */
/**
 * Desbordamiento de texto de estilo izquierdo.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const ELLIPSIS = 'ellipsis';

/**
 * Desbordamiento de texto de estilo central.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const VISIBLE = 'visible';

/**
 * Desbordamiento de texto de estilo derecho.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const HIDDEN = '';
